(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsExtraDayHolidayController', ['ItemTableService', AgendaSettingsExtraDayHolidayControllerFn]);

    /* controlle for main extra days and holidays */
    function AgendaSettingsExtraDayHolidayControllerFn(ItemTableService) {
        var vm = this;

        // table service data
        vm.overview = null;
        activate();

        /* activation work */
        function activate() {
            vm.overview = ItemTableService;
        }
    }
})();
